<template>
  <div class="form-content">
    <!-- <circle-spin v-if="is_loading"></circle-spin> -->
    <div class="table-ship">
      <data-table
        :columns="columns"
        :sortKey="sortKey"
        :sortOrders="sortOrders"
        @sort="sortBy"
        v-if="is_loading == false"
      >
        <tbody class="kt-datatable__body">
          <span v-for="data in cotiaciones" :key="data.id">
            <tr class="kt-datatable__row">
              <td class="td-table">
                <div class="image-table">
                  <img
                    :src="data.img"
                    alt=""
                    width="180px"
                    height="260px"
                    v-if="data.img"
                  />
                  <img
                    src="../../assets/images/image-package.png"
                    alt=""
                    width="180px"
                    height="260px"
                    v-else
                  />
                </div>
              </td>
              <td class="td-table">
                <span class="span-title">{{ data.title }}</span>
              </td>
              <td class="td-table">
                <span class="span-title"
                  ><a :href="data.url" target="_blank">url</a>
                </span>
              </td>
            </tr>
          </span>
        </tbody>
      </data-table>
    </div>

    <pagination
      :pagination="pagination"
      @changePagination="getPedidos"
      v-if="is_loading == false"
    ></pagination>
  </div>
</template>
<script>
import DataTable from "@/components/views/DataTable.vue";
import Pagination from "@/components/views/Pagination.vue";
import axios from "axios";
export default {
  props: ["idUser"],
  components: { DataTable, Pagination },
  created() {
    this.getPedidos();
  },
  data() {
    let sortOrders = {};
    let columns = [
      { label: "", name: "imagen", visible: true },
      { label: "Descripción", name: "description", visible: true },
      { label: "Url del Producto", name: "urlProduct", visible: true },
    ];
    columns.forEach((column) => {
      sortOrders[column.name] = -1;
    });
    return {
      cotiaciones: null,
      columns,
      sortKey: "updated_at",
      sortOrders: sortOrders,
      filterKey: "",
      tableData: {
        orderBy: "created_at",
        length: 4,
        page: 1,
      },

      pagination: {
        lastPage: "",
        currentPage: "",
        total: "",
        lastPageUrl: "",
        nextPageUrl: "",
        prevPageUrl: "",
        from: "",
        to: "",
      },
      is_loading: true,
    };
  },
  methods: {
    getPedidos(page) {
      this.is_loading = true;
      //   this.tableData.draw++;
      this.tableData.page = page;
      let url = process.env.API_URL + "/api/client/getQuotationList/" + this.idUser;
      // eslint-disable-next-line no-unreachable
      axios
        .get(url, { params: this.tableData })
        .then((response) => {
          this.cotiaciones = response.data.body.data;
          this.is_loading = false;
          this.configPagination(response.data.body);
        })
        .catch(() => {
          alert("No se obtuvieron resultados");
          this.is_loading = false;
          return;
        });
    },
    cleanInput() {
      this.tableData.filterValue = "";
    },
    configPagination(data) {
      this.pagination.lastPage = data.last_page;
      this.pagination.currentPage = data.current_page;
      this.pagination.total = data.total;
      this.pagination.lastPageUrl = data.last_page_url;
      this.pagination.nextPageUrl = data.next_page_url;
      this.pagination.prevPageUrl = data.prev_page_url;
      this.pagination.from = data.from;
      this.pagination.to = data.to;
      this.pagination.perPage = this.tableData.length;
    },
    sortBy(key) {
      this.sortKey = key;
      this.sortOrders[key] = this.sortOrders[key] * -1;
      this.tableData.orderBy = this.sortOrders;
      /* this.tableData.orderBy = this.getIndex(this.columns, 'name', key) */

      this.tableData.dir = this.sortOrders[key] === 1 ? "asc" : "desc";

      this.getPedidos();
    },
    getIndex(array, key, value) {
      return array.findIndex((i) => i[key] === value);
    },
  },
  computed: {
    filterColumns() {
      let activeFilterColumns = ["document_number", "email", "fullname", "cellphone"];
      return this.columns.filter((i) => activeFilterColumns.indexOf(i.name) > -1);
    },
  },
};
</script>

<style lang="css" scoped></style>



// WEBPACK FOOTER //
// CotizacionComponent.vue?4019a188